import { injectable } from "inversify";
import { ICacheProvider } from "../../domain/interfaces/cache-provider.interface";

@injectable()
export class NullCacheProvider implements ICacheProvider {
	public async get(key: string): Promise<object> {
		throw new Error("Not implemented");
	}

	public async has(key: string): Promise<boolean> {
		return false;
	}

	public async set(key: string, data: object, ttl): Promise<void> {
		return undefined;
	}

}
